import Swal from 'sweetalert2';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../../../styles/cases.css';
import { getCase, updateCase } from './../../../actions/case-actions';
import { Link, useParams, useNavigate } from 'react-router-dom';

function CreateComment(){
    const currentLink = "/casos/historial";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user.user);
    const params = useParams();
    const [loadData, setLoadData] = useState(true);
    const [currentData, setCurrentData] = useState({});

    const [form, setForm] = useState({
        comment: '',
        creationUser: user._id
    })

    useEffect(() => {
        const getFunction = (response) => {
            if(response.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: response.message
                });
            }else{
                //console.log(response.data);
                let type = response.data.caseType;
                response.data.caseType = type.charAt(0).toUpperCase() + type.slice(1);
                response.data.clientText = `${response.data.client.clientId.firstName} ${response.data.client.clientId.lastName}`;
                setCurrentData(response.data);
            }
        }

        if (loadData) {
            setLoadData(false);
            setCurrentData({});
            dispatch( getCase( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, user.token ]);

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = Object.values(form).some(x => x === null || x === '');
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar",
            });
        } else {
            
            let data = JSON.parse(JSON.stringify(currentData));
            data.comments.push(form);
                
            dispatch( updateCase( data, updateFunction, user.token) );
        }
        //console.log('enviando form...' + form.nombre + ' ' + form.apellido)
    }

    const updateFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            navigate(`${currentLink}/${params.id}`)

            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Comentario creado con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(currentData)
    }, [currentData]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={`${currentLink}/${params.id}`} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Nuevo comentario</h1>
                {Object.keys(currentData).length>0?
                    <form className="d-flex w-100 flex-wrap" onSubmit={handleOnSubmit}>
                        <span>Caso: <b>{currentData.caseType} - Exp {currentData.filingNumber} - Cliente {currentData.clientText}</b></span>
                        <div  className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'comment'}>Resumen</label>
                            <textarea id={'comment'} name={'comment'} placeholder={''} autoComplete="off" rows={5} cols={5} className="input-field" type="number" onChange={handleInputChange}></textarea>
                        </div>
                        <div className="d-flex justify-content-center w-100 my-2">
                            <button type="submit" className="primary-button save-button">Guardar &#43;</button>
                        </div>
                    </form>
                :null}
            </div>
        </div>
    );

}

export default CreateComment;
  